import {
  AngularComponentsModule,
  GoabTab,
  GoabTabs,
  GoabTabsOnChangeDetail,
} from '@abgov/angular-components';
import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { ProgressIndicatorService } from '@libs/services/progress-indicator.service';
import { CapacityReportListStateService } from '../../../../services-v2/states/capacity-report-list.state.service';

@Component({
  selector: 'app-capacity-reporting-search',
  imports: [CommonModule, AngularComponentsModule, GoabTabs, GoabTab],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './capacity-reporting-search.html',
  styleUrl: './capacity-reporting-search.scss',
})
export class CapacityReportingSearch {
  private readonly _capacityReportState = inject(
    CapacityReportListStateService
  );
  private readonly _progressIndicator = inject(ProgressIndicatorService);

  async onTabChange($event: GoabTabsOnChangeDetail) {
    const tabIndex = $event.tab;
    if (tabIndex) {
      this._progressIndicator.progressIndicatorMessage.set(
        'Loading capacity reports...'
      );
      this._progressIndicator.isProgressIndicator.set(true);
      this._capacityReportState.setTab = Number(tabIndex);
      await this._capacityReportState.loadCapacityReports();
      this._progressIndicator.isProgressIndicator.set(false);
    }
  }
}
